import type { PropsWithChildren } from "react";
import { useKeyboardInset } from "../../hooks/useKeyboardInset";
import { BrandHeader } from "../BrandHeader/BrandHeader";
import styles from "./PageShell.module.css";

interface PageShellProps {
  centered?: boolean;
}

export const PageShell = ({ centered = false, children }: PropsWithChildren<PageShellProps>) => {
  const shellRef = useKeyboardInset<HTMLDivElement>();

  return (
    <div ref={shellRef} className={styles.shell}>
      <BrandHeader />
      <main className={centered ? styles.centered : styles.main}>{children}</main>
    </div>
  );
};
